import { combineReducers } from 'redux';
import market from './Market/reducer';

const reducer = combineReducers({
  market,
});

export default reducer;
